import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=35b18a48&scoped=true"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=35b18a48&prod&scoped=true&lang=css"
import style1 from "./ProductsFilter.vue?vue&type=style&index=1&id=35b18a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b18a48",
  null
  
)

export default component.exports